import {
  IBaseAddress,
  IDeliveryInfo,
  IInvoiceAddress,
  IOrderPricesSummary,
  IPaymentInfo as ICartPaymentInfo,
} from 'src/pages/CartPage/model';

import { EPaymentGroup, ICartPrice } from '@model';

/** @see {isLastOrderValidatedCartResponse} ts-auto-guard:type-guard */
export interface ILastOrderValidatedCartResponse {
  orderAsLastTimeValidateCart: {
    data: {
      valid: boolean;
      freeDeliveryOptionFlag?: string;
      paymentInfo: IPaymentInfoResponse;
      cart: {
        cartId: string;
        pricesSummary: ICartPrice;
      };
    };
  };
}

export interface ILastOrderValidatedCart {
  prices: IOrderPricesSummary;
  freeDeliveryOptionFlag?: EFreeDeliveryOptionFlag;
  paymentInfo?: IPaymentInfo;
  valid: boolean;
}

/** @see {isValidateLastOrderCartRequest} ts-auto-guard:type-guard */
export interface IValidateLastOrderCartRequest {
  sameDeliveryAndInvoice: boolean;
  deliveryAddress: IBaseAddress;
  invoiceAddress: IInvoiceAddress;
  deliveryInfo: IDeliveryInfo;
  paymentInfo: IPaymentInfoRequest;
}

interface IPaymentInfoRequest extends Omit<ICartPaymentInfo, 'paymentGroups'> {
  paymentGroups: string[];
}

interface IPaymentInfoResponse extends Omit<IPaymentInfo, 'paymentGroups'> {
  paymentGroups: string[];
}

interface IPaymentInfo {
  paymentId: number;
  paymentGroups: EPaymentGroup[];
  paypalTokenAvailable: boolean;
}

export enum EFreeDeliveryOptionFlag {
  NONE = 'None',
  CHANGE_DELIVERY = 'ChangeDelivery',
  CHANGE_DELIVERY_TO_NOTINO_BRANCH = 'ChangeDeliveryToNotinoBranch',
  CHANGE_PAYMENT_TO_ONLINE = 'ChangePaymentToOnline',
  CHANGE_DELIVERY_AND_PAYMENT = 'ChangeDeliveryAndPayment',
}
